



























































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import CKEditor from "@/components/ckeditor.vue";

import TsUpload from "@/components/upload.vue";

import MyForm from "@/mixins/form";
import { stringify } from "qs";

@Component({
  components: {
    ckeditor: CKEditor,
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() appId!: number;

  cateList = [];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确认要添加吗？",
          onOk: async () => {
            var cateIds: string[] = values.cate_ids;
            const res = await this.$store.dispatch("article/add", {
              app_id: this.appId,
              ...values,
              cate_ids: JSON.stringify(cateIds.map((el) => parseInt(el))),
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success("添加成功");
              this.handleCancel();
            } else {
              this.$message.error("添加失败");
            }
          },
        });
      }
    });
  }

  async loadCate() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("articleCate/list");
    if (res && res.Data && res.Data.data && res.Data.data.length > 0) {
      console.log("cate_list", res.Data);
      this.cateList = res.Data.data;
    }
    this.spinLoading = false;
  }

  mounted() {
    this.loadCate();
  }
}
